import { connect } from "react-redux";
import { getSiteId } from "@template/state/modules/regionalStore";
import BasicWelcomeMessage from "./BasicWelcomeMessage";

const mapStateToProps = state => ({
  redirectUrl: state.welcomeMessage.redirectUrl,
  text: state.welcomeMessage.text,
  country: state.welcomeMessage.country,
  siteId: getSiteId(state)
});

export default connect(mapStateToProps)(BasicWelcomeMessage);
